import { useMutation, useQueryClient } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { HttpResponse, LinkedJobResponse, LinkJobRequest } from "@/types";

export function useCreateAddJobLink() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      jobId,
      targetJobId,
    }: {
      jobId: string;
      targetJobId: string;
    }) => {
      const path = `jobs/${jobId}/links`;
      const res = await guacHttpClient.post<
        LinkedJobResponse[],
        HttpResponse<LinkedJobResponse[]>,
        LinkJobRequest
      >(path, { targetJobId });
      return res.data;
    },
    onSuccess: () => {
      // Linking changes every group member's family list, not just the two
      // jobs involved — invalidate all cached link lists.
      void queryClient.invalidateQueries({ queryKey: ["job-links"] });
    },
  });
}
